import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useMediaQuery } from '@mui/material';
import getStyles from './styles';

const Banner = () => {
  const navigate = useNavigate();
  const isTablet = useMediaQuery('(max-width: 768px)');
  const isMobileL = useMediaQuery('(max-width: 425px)');
  const isMobileM = useMediaQuery('(max-width: 375px)');
  const isMobileS = useMediaQuery('(max-width: 360px)');
  const isMobileXS = useMediaQuery('(max-width: 320px)');

  const styles = getStyles({
    isTablet,
    isMobileL,
    isMobileM,
    isMobileS,
    isMobileXS
  });

  useEffect(() => {
    const preloadImages = [
      '/images/main-img.avif',
      '/images/banner-1.webp',
      '/images/roket.avif',
      '/images/icon.avif',
      '/images/shape-img-1.avif',
      '/images/line.avif',
      '/images/mountain-2.webp'
    ];

    preloadImages.forEach((image) => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = image;
      link.as = 'image';
      document.head.appendChild(link);
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Amizhth: Leading IT Consulting & Software Development company in India{' '}
        </title>
      </Helmet>
      <link
        rel="preload"
        href="/images/main-img.avif"
        as="image"
        type="image/avif"
      />
      <link
        rel="preload"
        href="/images/banner-1.webp"
        as="image"
        type="image/webp"
      />
      <link
        rel="preload"
        href="/images/roket.avif"
        as="image"
        type="image/avif"
      />
      <link
        rel="preload"
        href="/images/icon.avif"
        as="image"
        type="image/avif"
      />
      <link
        rel="preload"
        href="/images/shape-img-1.avif"
        as="image"
        type="image/avif"
      />
      <link
        rel="preload"
        href="/images/line.avif"
        as="image"
        type="image/avif"
      />
      <link
        rel="preload"
        href="/images/mountain-2.webp"
        as="image"
        type="image/webp"
      />

      {/* Load Swiper JS after the page load */}
      <script
        src="https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js"
        defer
      ></script>

      <div className="slider_area d-flex align-items-center slider18" id="home">
        <div style={styles.overlayContainer}>
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: 'easeOut' }}
            style={styles.contentWrapper}
          >
            <div style={styles.textContainer}>
              <motion.div style={styles.animatedText}>
                {[
                  'Blink',
                  'twice',
                  '—',
                  'your',
                  'website',
                  'will',
                  'be',
                  'ready.'
                ].map((word, index) => (
                  <motion.span
                    key={index}
                    initial={{
                      opacity: 0,
                      y: -30,
                      rotateX: -90,
                      scale: 0.5
                    }}
                    animate={{
                      opacity: 1,
                      y: 0,
                      rotateX: 0,
                      scale: 1
                    }}
                    transition={{
                      delay: 0.3 + index * 0.12,
                      duration: 0.8,
                      ease: [0.34, 1.56, 0.64, 1],
                      type: 'spring',
                      stiffness: 100
                    }}
                    whileHover={{
                      scale: 1.2,
                      y: -5,
                      color: '#6dd5fa',
                      textShadow:
                        '0 0 30px rgba(109,213,250,1), 0 5px 20px rgba(0,0,0,0.5)',
                      filter: 'brightness(1.3)',
                      transition: { duration: 0.3 }
                    }}
                    style={styles.wordSpan}
                  >
                    {word}
                    <motion.div
                      initial={{ scaleX: 0 }}
                      whileHover={{ scaleX: 1 }}
                      style={styles.wordUnderline}
                    />
                  </motion.span>
                ))}
              </motion.div>
              {/* {[...Array(12)].map((_, i) => (
                <motion.div
                  key={i}
                  animate={{
                    scale: [0, 1.5, 0],
                    opacity: [0, 1, 0],
                    rotate: [0, 360, 720],
                    x: [0, Math.cos((i * 30 * Math.PI) / 180) * 50, 0],
                    y: [0, Math.sin((i * 30 * Math.PI) / 180) * 50, 0]
                  }}
                  transition={{
                    duration: 3,
                    repeat: Infinity,
                    delay: i * 0.25,
                    ease: 'easeInOut'
                  }}
                  style={{
                    position: 'absolute',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: i % 2 === 0 ? '#6dd5fa' : '#a855f7',
                    boxShadow: `0 0 15px ${i % 2 === 0 ? '#6dd5fa' : '#a855f7'}`,
                    top: '50%',
                    left: '50%',
                    pointerEvents: 'none'
                  }}
                />
              ))}
              {[...Array(3)].map((_, i) => (
                <motion.div
                  key={`star-${i}`}
                  animate={{
                    x: [-100, 1000],
                    y: [-50, 100],
                    opacity: [0, 1, 1, 0]
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    delay: i * 2,
                    ease: 'easeInOut',
                    times: [0, 0.1, 0.9, 1]
                  }}
                  style={{
                    position: 'absolute',
                    width: '3px',
                    height: '3px',
                    borderRadius: '50%',
                    background: '#fff',
                    boxShadow: '0 0 20px #fff, 0 0 10px #6dd5fa',
                    top: `${20 + i * 20}%`,
                    left: '-100px',
                    pointerEvents: 'none'
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      width: '40px',
                      height: '2px',
                      background: 'linear-gradient(90deg, #fff, transparent)',
                      right: '0',
                      top: '50%',
                      transform: 'translateY(-50%)'
                    }}
                  />
                </motion.div>
              ))} */}
            </div>
            <motion.div
              initial={{ opacity: 0, scale: 0.5, rotateY: -180 }}
              animate={{ opacity: 1, scale: 1, rotateY: 0 }}
              transition={{
                delay: 1.5,
                duration: 1.2,
                type: 'spring',
                stiffness: 80
              }}
              style={styles.buttonContainer}
            >
              {/* <motion.button
                whileHover={{
                  scale: 1.15,
                  rotateX: 8,
                  rotateY: 5,
                  boxShadow:
                    '0 25px 50px rgba(106, 98, 255, 0.7), 0 0 50px rgba(109,213,250,0.5)',
                  y: -5
                }}
                whileTap={{
                  scale: 0.98,
                  rotateX: 0,
                  rotateY: 0,
                  y: 2
                }}
                style={styles.ctaButton}
              >
                <motion.div
                  animate={{
                    backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
                  }}
                  transition={{
                    duration: 5,
                    repeat: Infinity,
                    ease: 'linear'
                  }}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background:
                      'linear-gradient(135deg, transparent, rgba(255,255,255,0.2), transparent)',
                    backgroundSize: '200% 100%',
                    zIndex: 0
                  }}
                />
                <motion.div
                  animate={{
                    x: ['-200%', '200%'],
                    opacity: [0, 1, 0]
                  }}
                  transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: 'easeInOut',
                    repeatDelay: 1.5
                  }}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '30%',
                    height: '100%',
                    background:
                      'linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)',
                    transform: 'skewX(-20deg)',
                    filter: 'blur(3px)'
                  }}
                />
                <motion.span
                  animate={{
                    rotate: [0, 360],
                    scale: [1, 1.2, 1]
                  }}
                  transition={{
                    rotate: { duration: 2, repeat: Infinity, ease: 'linear' },
                    scale: { duration: 1, repeat: Infinity, ease: 'easeInOut' }
                  }}
                  style={styles.buttonIcon}
                >
                  ⚡
                </motion.span>
                <div style={styles.buttonContent}>
                  <span style={styles.buttonText}>
                    Fully functional Website <br /> In two days
                  </span>
                </div>
                {[...Array(4)].map((_, i) => (
                  <motion.div
                    key={i}
                    animate={{
                      opacity: [0.3, 1, 0.3],
                      scale: [1, 1.5, 1]
                    }}
                    transition={{
                      duration: 2,
                      repeat: Infinity,
                      delay: i * 0.5,
                      ease: 'easeInOut'
                    }}
                    style={{
                      position: 'absolute',
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      background: '#6dd5fa',
                      boxShadow: '0 0 10px #6dd5fa',
                      ...(i === 0 && { top: '5px', left: '5px' }),
                      ...(i === 1 && { top: '5px', right: '5px' }),
                      ...(i === 2 && { bottom: '5px', left: '5px' }),
                      ...(i === 3 && { bottom: '5px', right: '5px' }),
                      pointerEvents: 'none'
                    }}
                  />
                ))}
              </motion.button> */}
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 2, duration: 0.8 }}
                whileHover={{
                  scale: 1.1,
                  color: '#6dd5fa',
                  textShadow: '0 0 20px rgba(109, 213, 250, 1)',
                  y: -2
                }}
                whileTap={{ scale: 0.95 }}
                style={styles.startNowText}
                onClick={() => navigate('/two-days-mvp')}
              >
                Know More !
                <motion.div
                  style={{
                    height: '2px',
                    background: '#6dd5fa',
                    width: '100%',
                    marginTop: '2px',
                    borderRadius: '2px'
                  }}
                  initial={{ scaleX: 0 }}
                  whileHover={{ scaleX: 1 }}
                  transition={{ duration: 0.3 }}
                />
              </motion.div>
              {/* {[...Array(8)].map((_, i) => (
                <motion.div
                  key={i}
                  animate={{
                    rotate: 360,
                    scale: [1, 1.5, 1],
                    opacity: [0.4, 1, 0.4]
                  }}
                  transition={{
                    rotate: { duration: 4, repeat: Infinity, ease: 'linear' },
                    scale: { duration: 2, repeat: Infinity, ease: 'easeInOut' },
                    opacity: {
                      duration: 2,
                      repeat: Infinity,
                      ease: 'easeInOut'
                    },
                    delay: i * 0.5
                  }}
                  style={{
                    position: 'absolute',
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    background: i % 2 === 0 ? '#6dd5fa' : '#a855f7',
                    boxShadow: `0 0 12px ${i % 2 === 0 ? '#6dd5fa' : '#a855f7'}`,
                    top: '50%',
                    left: '50%',
                    transformOrigin: `${60 * Math.cos((i * 45 * Math.PI) / 180)}px ${60 * Math.sin((i * 45 * Math.PI) / 180)}px`,
                    pointerEvents: 'none'
                  }}
                />
              ))}
              {[...Array(6)].map((_, i) => (
                <motion.div
                  key={`rise-${i}`}
                  animate={{
                    y: [0, -80, -80],
                    opacity: [0, 1, 0],
                    scale: [0.5, 1.5, 0]
                  }}
                  transition={{
                    duration: 3,
                    repeat: Infinity,
                    delay: i * 0.5,
                    ease: 'easeOut'
                  }}
                  style={{
                    position: 'absolute',
                    width: '5px',
                    height: '5px',
                    borderRadius: '50%',
                    background: '#ffffff',
                    boxShadow: '0 0 10px #6dd5fa',
                    bottom: '0',
                    left: `${15 + i * 15}%`,
                    pointerEvents: 'none'
                  }}
                />
              ))} */}
            </motion.div>
          </motion.div>
        </div>
        <div className="container">
          <div className="row d-flex align-items-center">
            {/* Left Content */}
            <div className="col-md-6 col-lg-6">
              <div className="single_slider wow fadeInUp">
                <div className="slider_content">
                  <div className="slider_text">
                    <div className="slider_text_inner">
                      <h5></h5>
                      <h2 className="pt-40">
                        Let’s Build Your Digital Footprints!
                      </h2>

                      <p>
                        Amizhth Techno Solutions offers end-to-end IT consulting
                        and services tailored to your business needs. From
                        building secure mobile app development solutions to
                        creating fast, responsive web development services, we
                        help startups and enterprises launch scalable,
                        future-ready digital platforms. Secure, Scale, Succeed
                      </p>
                    </div>
                    <div className="slider_button pt-3 d-flex">
                      <div className="button">
                        <Link to="/contact">
                          Let&apos;s Talk <i className="bi bi-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="em-hero-inner-shape rotateme">
                  <img src="/images/box.avif" alt="Box Shape" loading="eager" />
                </div>
                <div className="em-hero-inner-shape1">
                  <img
                    src="/images/line.avif"
                    alt=""
                    loading="eager"
                    srcSet="/images/line.avif"
                  />
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-md-6 col-lg-6">
              <div className="hero_section_thumb wow fadeInDown">
                <div className="hero-main-thumb">
                  <img
                    src="/images/main-img.avif"
                    alt=""
                    loading="eager"
                    // srcSet="/images/main-img.avif 1x, /images/main-img@2x.avif 2x"
                    // sizes="(max-width: 768px) 100vw, 50vw"
                  />
                </div>
                <div className="em-hero-icon-thumb bounce-animate4">
                  <img
                    src="/images/shape-img-1.avif"
                    alt=""
                    loading="eager"
                    srcSet="/images/shape-img-1.avif"
                  />
                </div>
                <div className="em-hero-inner-thumb2 bounce-animate">
                  <img
                    src="/images/roket.avif"
                    alt=""
                    loading="eager"
                    srcSet="/images/roket.avif"
                  />
                </div>
                <div className="em-hero-inner-thumb4 bounce-animate5">
                  <img
                    src="/images/icon.avif"
                    alt=""
                    loading="eager"
                    srcSet="/images/icon.avif"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Image - Lazy load background */}
      <img
        src="/images/mountain-2.webp"
        alt=""
        loading="lazy"
        srcSet="/images/mountain-2.webp"
        className="mountain-img img-fluid"
      />
    </>
  );
};

export default Banner;
